module.exports = __webpack_public_path__ + "img/viewPictureWhite.0b073431.svg";